import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.tsx';
import { FC, useState } from 'react';
import {
  StreamQueryQuery,
  StreamState,
  StreamType,
} from '@/__generated__/graphql.ts';
import { PublishStreamModal } from '@/components/streams/publish-stream/publish-stream-modal.tsx';
import { InviteUsersModal } from '@/components/streams/stream-invite/invite-users-modal.tsx';
import { UpdateStreamModal } from '@/components/streams/update-stream-modal.tsx';
import { followStreamButton } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';
import { paidDataToFormValues } from '@/utils/paid-data.ts';

export const MeStreamActions: FC<{
  stream: NonNullable<StreamQueryQuery['stream']>;
}> = ({ stream }) => {
  const isTablet = useIsTablet();
  const [inviteModalOpen, onInviteModalOpenChange] = useState(false);

  const publishDisabled = stream.isEmpty && !stream.customTargetsData;

  return (
    <>
      <UpdateStreamModal
        key={
          stream.customTargetsData
            ? 'custom-stream-update-modal'
            : 'regular-stream-update-modal'
        }
        name={stream.name}
        descriptionJson={stream.descriptionJson}
        label={stream.label}
        streamId={stream.id}
        streamCategory={stream.streamCategory}
        paidData={paidDataToFormValues(stream.paidData)}
        streamType={stream.streamType}
        customTargetsData={stream.customTargetsData}
        packageOnly={stream.packageOnly}
        apiAccessEnabled={stream.apiAccessEnabled}
        trigger={
          <Button
            variant={'secondary'}
            size={isTablet ? 'medium' : 'small'}
            className={followStreamButton}
          >
            Edit
          </Button>
        }
      />
      {stream.streamState === StreamState.Draft ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <PublishStreamModal
                trigger={
                  <Button
                    variant={'primary'}
                    size={isTablet ? 'medium' : 'small'}
                    className={followStreamButton}
                    disabled={publishDisabled}
                  >
                    Publish
                  </Button>
                }
              />
            </div>
          </TooltipTrigger>
          {publishDisabled ? (
            <TooltipContent description="Add at least one post before you can publish" />
          ) : null}
        </Tooltip>
      ) : stream.streamType === StreamType.Private ? (
        <Button
          size={isTablet ? 'medium' : 'small'}
          startIcon={<PlusIcon />}
          className={followStreamButton}
          onClick={() => onInviteModalOpenChange(true)}
        >
          Invite others
        </Button>
      ) : null}

      {inviteModalOpen ? (
        <InviteUsersModal
          open={inviteModalOpen}
          onOpenChange={onInviteModalOpenChange}
        />
      ) : null}
    </>
  );
};
